import { COLOR } from "../../../../common/Color"
import { FontType } from "../../../../common/TextUtils"
import { Buttons } from "../../../generic-sprites/Buttons"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { TimeMachineColor, TmSprite } from "../TimeMachineAssets"

export class DashboardButton {

    button: Phaser.Sprite
    text: Phaser.Text

    constructor(private game: Phaser.Game, name: string, x: number, y: number, scale = 1, left?: boolean, group?: Phaser.Group) {
        this.button = Sprites.add(game, TmSprite.DASHBOARD_BUTTON, {x, y, scale, group})
        if (left) {
            this.button.anchor.setTo(0.5, 0.5)
            this.button.scale.x *= -1
            this.button.anchor.setTo(0, 0)
        }
        this.text = PhaserText.create(game, name, {type: FontType.FUTURISTIC, color: TimeMachineColor.LIGHT, fontPx: 22, group})
        Sprites.centerSpriteInSprite(this.button, this.text)
        this.text.x += Scale.x(left ? 0.005 : -0.005)
    }

    onClick = (action: () => void) => {
        this.active()
        Buttons.makeSpriteButton(this.button, () => {
            action()
        })
    }

    onClickPlay = (audioKey: string) => {
        this.button.frame = 1
        const audio = this.game.add.audio(audioKey)
        audio.onStop.add(() => this.button.frame = 1)
        Buttons.makeSpriteButton(this.button, () => {
            audio.play()
            this.button.frame = 2
        })
    }

    undoButton = () => {
        Buttons.undoSpriteButton(this.button)
        this.inactive()
    }

    active = () => {
        this.button.frame = 1
        this.text.addColor(COLOR.black, 0)
    }

    inactive = () => {
        this.button.frame = 0
        this.text.addColor(TimeMachineColor.LIGHT, 0)
    }

    pressed = () => {
        Buttons.undoSpriteButton(this.button)
        this.button.frame = 2
        this.text.addColor(COLOR.black, 0)
    }
}
